export default __webpack_public_path__ + "static/media/windradar_logo.81132c39.png";